<template>
  <div class="process-design">
    <processNodeIcon class="bpmn-elements" />

    <BPMNEditor
      class="bpmn-editor"
      ref="bpmnEditor"
      :initProcessConfig="processData"
      @byCurrentEditNode="getCurrentEditNode"
      @byRootElement="getRootElement"
      @byEventBus="getEventBus"
      @byModdle="getModdle"
      @byModeling="getModeling"
    />

    <processNodeForm
      ref="processNodeForm"
      :moddle="moddle"
      :modeling="modeling"
      :conditions="processData.conditions"
      :eventBus="eventBus"
    />

    <!-- action -->
    <div class="button">
      <el-button type="primary" style="margin-right:20px;" @click="confirmEditProcess">提交</el-button>
      <el-button plain @click="cancleEditProcess">取消</el-button>
    </div>
  </div>
</template>

<script>
import BPMNEditor from "@/components/ProcessDesign/BpmnEditor/bpmnEditor.vue";
import processNodeIcon from "@/components/ProcessDesign/BpmnEditor/PaneLeft.vue";
import processNodeForm from "@/components/ProcessDesign/BpmnEditor/PaneRight.vue";
import defaultBpmn from "@/components/ProcessDesign/config/default.bpmn";
export default {
  components: {
    BPMNEditor,
    processNodeIcon,
    processNodeForm
  },

  beforeCreate() {
    this.$route.meta.title = this.$route.query.type;
  },

  created() {
    this.setProcessData(this.$route.query.id);
  },

  data: function() {
    return {
      currentConfig: undefined,
      currentNode: undefined,
      dialogVisible: true,
      moddle: null,
      modeling: null,
      processData: {},
      eventBus: null
    };
  },

  methods: {
    async setProcessData(processId) {
      let xml = await this.$api.getOneProcessDetails(processId);

      let conditions = await this.$api.getProcessConditions(processId);

      // conditions = [
      //   { code: "totalAmount", name: "金额", type: "number" },
      //   { code: "departmentId", name: "部门", type: "department" },
      //   { code: "createEmployeeId", name: "制单人", type: "employee" },
      //   { code: "project", name: "项目", type: "project" },
      //   {
      //     code: "costTypeIds",
      //     name: "费用明细",
      //     type: "costTypes",
      //     valueFrom: "api",
      //     api: "/enumType/getByTypeCode/{enumTypeCode}"
      //   }
      // ];

      xml = xml || defaultBpmn;

      this.processData = {
        template: xml,
        processId: processId,
        conditions: conditions
      };
    },

    getCurrentEditNode(el) {
      this.$refs.processNodeForm.formDrawerStatus = true;
      // this.currentNode = node;
      this.$refs.processNodeForm.setInitialFormData(el);
    },


    getRootElement(root) {
      this.$refs.processNodeForm.rootElement = root;
    },

    getEventBus(eventBus) {
      this.eventBus = eventBus
    },


    getModdle(moddle) {
      this.moddle = moddle;
    },

    getModeling(modeling) {
      this.modeling = modeling;
    },

    cancleEditProcess() {
      this.$confirm("您的编辑将不会保存, 是否继续?", "提示", {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: "warning"
      }).then(_ => {
        this.$router.push({ name: "process" });
      });
    },

    confirmEditProcess() {
      this.$refs.bpmnEditor.validateSequenceFlow();
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";

.process-design {
  height: $contentHeight;
  min-height: 800px;
  display: flex;
  padding: 20px;
  position: relative;
}

.bpmn-elements {
  width: 200px;
  margin-right: 10px;
  background-color: #fafafa;
}

.bpmn-editor {
  height: 100%;
  background: #fff;
  flex: 1;
  background-image: linear-gradient(
      to right,
      rgba(111, 111, 111, 0.1) 1px,
      transparent 1px
    ),
    linear-gradient(to bottom, rgba(188, 188, 188, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
}

.button {
  position: absolute;
  bottom: 50px;
  right: 50px;
}
</style>
